/* Encabezado, pie y carrito HerBalance: contador del carrito y carrito «Tu pedido» (el menú del celular salió en CHANGE-054).
   Sin dependencias. Se genera con construir_marco.py (este es el archivo fuente). */

/* UTM de la visita: la suscripción se compra en otro sitio y tiene que llevarlos, aunque la clienta haya
   llegado por un anuncio a otra página. Se guardan los de la primera página que los traiga. */
(() => {
  try {
    const q = new URLSearchParams(location.search);
    const nuevos = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid'].forEach(k => { if (q.get(k)) nuevos[k] = q.get(k); });
    if (Object.keys(nuevos).length) sessionStorage.setItem('ova2-utm', JSON.stringify(nuevos));
  } catch (e) {}
})();

/* Contador del carrito en el encabezado. */
window.OVA2_BURBUJA = (() => {
  const cuentas = [...document.querySelectorAll('[data-ova2-cuenta]')];
  const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const pintar = c => cuentas.forEach(el => {
    el.textContent = c.item_count;
    el.hidden = !c.item_count;
    const a = el.closest('a');
    if (a) a.setAttribute('aria-label', 'Carrito (' + c.item_count + ')');
  });
  const refrescar = () => fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(pintar).catch(() => {});
  if (cuentas.length) {
    let t = 0;
    const luego = () => { clearTimeout(t); t = setTimeout(refrescar, 1200); };
    window.addEventListener('pageshow', e => { if (e.persisted) refrescar(); });
    document.addEventListener('click', e => { if (e.target.closest && e.target.closest('[data-instant-action-type]')) luego(); }, true);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) luego(); });
  }
  return c => { if (c && cuentas.length) pintar(c); };
})();

/* Carrito «Tu pedido»: siempre lee el carrito real de Shopify (/cart.js), deja elegir 1, 2 o 3 frascos (el total lo
   calcula Shopify con los descuentos automáticos) y pasar a suscripción. Reemplaza al carrito de Instant, que solo
   veía lo que se agregaba con sus propios botones. Ver SPEC-carrito-propio.md. */
(() => {
  const dlg = document.getElementById('ova2-carrito');
  const cfgEl = document.getElementById('ova2-carrito-config');
  if (!dlg || !cfgEl || typeof dlg.showModal !== 'function') return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const cuerpo = dlg.querySelector('[data-ova2-carrito-cuerpo]');
  const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CAB = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const PLAN = { 1: '1-frasco', 2: '2-frascos', 3: '3-frascos' };
  const CADA = { 1: 'cada mes', 2: 'cada 2 meses', 3: 'cada 3 meses' };
  const pesos = n => '$' + Math.round(n).toLocaleString('es-CO');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pct = (precio, n) => Math.floor((1 - precio / (cfg.unica[1] * n)) * 100);
  let carrito = null, modo = 'unica', quien = null, ocupado = false;

  const espera = ms => new Promise(ok => setTimeout(ok, ms));
  const leer = async () => {
    const r = await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart.js ' + r.status);
    carrito = await r.json();
  };
  const principal = () => carrito.items.find(i => i.variant_id === cfg.variante) || carrito.items[0];
  const urlSuscripcion = n => {
    const u = new URL(String(cfg.susUrl || '').replace(/\/+$/, '') + '/' + PLAN[n], location.href);
    try { Object.entries(JSON.parse(sessionStorage.getItem('ova2-utm') || '{}')).forEach(([k, v]) => u.searchParams.set(k, v)); } catch (e) {}
    new URLSearchParams(location.search).forEach((v, k) => { if (/^(utm_|fbclid$|ttclid$)/.test(k)) u.searchParams.set(k, v); });
    return u.toString();
  };

  function pintar(aviso = '') {
    const alerta = aviso ? `<p class="carrito-error" role="alert">${esc(aviso)}</p>` : '';
    if (!carrito) {
      // No se pudo leer el carrito: nunca decir «vacío» sin saberlo. La página /cart lo muestra sin JavaScript.
      cuerpo.innerHTML = `<div class="carrito-vacio"><p>No pudimos cargar tu pedido. Revisa tu conexión e inténtalo de nuevo.</p><a class="btn btn-naranja" href="${raiz}cart">Ver mi carrito</a></div>`;
      return;
    }
    if (!carrito.item_count) {
      modo = 'unica';
      cuerpo.innerHTML = `${alerta}<div class="carrito-vacio"><p>Tu carrito está vacío.</p><a class="btn btn-naranja" href="${esc(cfg.productoUrl)}">Ver OvaBloom</a></div>`;
      return;
    }
    const l = principal();
    const n = l.quantity;
    const enRango = n >= 1 && n <= 3;
    if (!enRango || !cfg.susActiva) modo = 'unica';
    const packs = [1, 2, 3].map(k => {
      const precio = modo === 'sus' ? cfg.sus[k] : cfg.unica[k];
      const a = pct(precio, k);
      return `<button type="button" class="pack${k === n ? ' activo' : ''}" data-ova2-cant="${k}" aria-pressed="${k === n}">` +
        `<b>${k} ${k === 1 ? 'frasco' : 'frascos'}</b><span>${pesos(precio)}</span><small>${a > 0 ? 'Ahorra ' + a + ' %' : 'Precio normal'}</small></button>`;
    }).join('');
    const modos = cfg.susActiva ? `<div class="modos" role="radiogroup" aria-label="Cómo lo quieres recibir">
        <button type="button" role="radio" class="modo${modo === 'unica' ? ' activo' : ''}" aria-checked="${modo === 'unica'}" data-ova2-modo="unica"><b>Compra única</b><span>Un solo pedido, sin suscripción</span></button>
        <button type="button" role="radio" class="modo${modo === 'sus' ? ' activo' : ''}" aria-checked="${modo === 'sus'}" data-ova2-modo="sus"${enRango ? '' : ' disabled'}><b>Suscripción${enRango ? ' · ahorra ' + pct(cfg.sus[n], n) + ' %' : ''}</b><span>Te llega sola${enRango ? ' ' + CADA[n] : ''}. Pausas o cancelas cuando quieras</span></button>
      </div>` : '';
    // Los textos de cada modo son los mismos de la PDP (pdp.js: INCLUYE y la nota bajo el botón).
    let totales, cta, nota, hechos;
    if (modo === 'sus') {
      totales = `<div class="fila"><span>Envío</span><b>Gratis</b></div><div class="fila total"><span>Se cobran</span><b>${pesos(cfg.sus[n])} ${CADA[n]}</b></div>`;
      cta = `<a class="btn btn-naranja carrito-cta" href="${esc(urlSuscripcion(n))}">Suscribirme · ${pesos(cfg.sus[n])}</a>`;
      nota = 'La suscripción se paga en línea. Te avisamos antes de cada envío.';
      hechos = `<li>Envío gratis</li><li>Ahorras ${pesos(cfg.unica[n] - cfg.sus[n])} en cada envío</li><li>Soporte prioritario por WhatsApp</li>`;
    } else {
      const ahorro = carrito.total_discount ? `<div class="fila ahorro"><span>Ahorras</span><b>${pesos(carrito.total_discount / 100)}</b></div>` : '';
      totales = `${ahorro}<div class="fila"><span>Envío</span><b>Gratis</b></div><div class="fila total"><span>Total</span><b>${pesos(carrito.total_price / 100)}</b></div>`;
      cta = `<a class="btn btn-naranja carrito-cta" href="${raiz}checkout">Ir a pagar · ${pesos(carrito.total_price / 100)}</a>`;
      nota = 'Llega en 3 a 7 días hábiles.';
      hechos = `<li>Envío gratis</li><li>Garantía de 90 días · <a href="${esc(cfg.garantiaUrl)}">aplican condiciones</a></li>`;
    }
    const otras = carrito.items.filter(i => i !== l).map(i =>
      `<li><span>${esc(i.product_title)} × ${i.quantity}</span><b>${pesos(i.final_line_price / 100)}</b><button type="button" class="quitar" data-ova2-quitar="${esc(i.key)}">Quitar</button></li>`).join('');
    cuerpo.innerHTML = `${alerta}
      <div class="carrito-item">
        <img src="${esc(cfg.img[enRango ? n : 3])}" alt="" width="64" height="64">
        <div><b>${esc(cfg.nombre)}</b><span>${esc(cfg.detalle)}</span>${enRango ? '' : `<span class="aviso">Tienes ${n} frascos. Elige 1, 2 o 3.</span>`}</div>
        <button type="button" class="quitar" data-ova2-quitar="${esc(l.key)}" aria-label="Quitar ${esc(cfg.nombre)} del carrito">Quitar</button>
      </div>
      <p class="carrito-sub">¿Cuántos frascos?</p>
      <div class="packs">${packs}</div>
      ${modos}
      ${otras ? `<ul class="otras">${otras}</ul>` : ''}
      <div class="carrito-totales">${totales}</div>
      ${cta}
      <p class="carrito-nota">${nota}</p>
      <ul class="carrito-hechos">${hechos}</ul>`;
  }

  async function cambiar(key, cantidad) {
    if (ocupado) return;
    ocupado = true; cuerpo.classList.add('ocupado');
    const pedir = () => fetch(raiz + 'cart/change.js', { method: 'POST', headers: CAB, body: JSON.stringify({ id: key, quantity: cantidad }) });
    let bien = false;
    try {
      let r = await pedir();
      // Shopify a veces responde 503 o 429 por un momento (visto en vivo el 1-oct): se reintenta una vez.
      if (r.status === 429 || r.status >= 500) { await espera(900); r = await pedir(); }
      bien = r.ok;
    } catch (e) {}
    // Siempre se vuelve a leer: lo que se pinta es el carrito real, haya funcionado el cambio o no.
    try { await leer(); } catch (e) { bien = false; }
    pintar(bien ? '' : 'No pudimos actualizar tu pedido. Intenta de nuevo.');
    window.OVA2_BURBUJA && window.OVA2_BURBUJA(carrito);
    ocupado = false; cuerpo.classList.remove('ocupado');
  }

  async function abrir(desde) {
    quien = desde || document.activeElement;
    if (!dlg.open) dlg.showModal();
    try { await leer(); } catch (e) {
      try { await espera(800); await leer(); } catch (e2) { carrito = null; }
    }
    pintar(); window.OVA2_BURBUJA && window.OVA2_BURBUJA(carrito);
  }

  dlg.addEventListener('close', () => { if (quien && quien.focus) quien.focus(); });
  dlg.addEventListener('click', e => {
    if (e.target === dlg || e.target.closest('[data-ova2-carrito-cerrar]')) { dlg.close(); return; }
    const c = e.target.closest('[data-ova2-cant]');
    if (c) { const l = principal(); if (l && Number(c.dataset.ova2Cant) !== l.quantity) cambiar(l.key, Number(c.dataset.ova2Cant)); return; }
    const m = e.target.closest('[data-ova2-modo]');
    if (m && !m.disabled) { modo = m.dataset.ova2Modo; pintar(); return; }
    const q = e.target.closest('[data-ova2-quitar]');
    if (q) cambiar(q.dataset.ova2Quitar, 0);
  });
  // El ícono del encabezado abre «Tu pedido» en vez de ir a /cart. También los botones de las páginas de Instant
  // que abrían su carrito: sin su panel en el pie no harían nada.
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-ova2-carrito-abrir], [data-instant-action-type="trigger-instant-cart"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    abrir(a);
  }, true);
  // En las páginas de Instant, sus «COMPRAR AHORA» agregan con Instant: al terminar, se abre «Tu pedido».
  document.addEventListener('instant:add-to-cart', () => setTimeout(() => abrir(), 250));
  window.OVA2_CARRITO = { abrir };
})();
